import React from 'react';

export default ({children, title, id = 'pageLayout', fixedWidth = false}) => (
  <div className="mhd--full-page" id={id}>
    <div className="mhd-header">
      <h1>{title}</h1>
      <hr />
    </div>

    <div
      className={`mhd--full-page-content ${
        fixedWidth ? 'fixed-width' : 'fluid'
      }`}
    >
      {children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Common/Structure/PageLayout.js